import React from "react";
import ReservationBuilderSegment from "./ReservationBuilderSegment";
import ReservationBuilderHelper from "./ReservationBuilderHelper";

export default class ReservationBuilderSegments extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (
      this.props.reservation &&
      this.props.reservation.reservation_segments &&
      this.props.reservation.reservation_segments.length
    ) {
      // var taken_room_groups = [];
      // var taken_room_identifiers = [];

      const [taken_room_types, taken_room_ids] =
        ReservationBuilderHelper.taken_room_types_and_ids(
          this.props.reservation.reservation_segments,
          this.props.check_in_date,
          this.props.check_out_date
        );

      var room_type_segments = {};
      var segments = this.props.reservation.reservation_segments.map(
        (segment) => {

          return (
            <ReservationBuilderSegment
              promo_code={self.props.promo_code}
              segments={self.props.reservation.reservation_segments}
              segment={segment}
              guest_types={self.props.guest_types}
              date_format={self.props.date_format}
              number_format={self.props.number_format}
              group_contract={self.props.group_contract}
              key={segment.id}
              open={segment.id === self.props.active_segment_id}
              // taken_room_groups={taken_room_groups}
              // taken_room_identifiers={taken_room_identifiers}
              room_type_segments={room_type_segments}
              taken_room_types={taken_room_types}
              taken_room_ids={taken_room_ids}
            />
          );
        }
      );

      return (
        <fieldset>
          <legend>
            <span>{I18n.t("rooms_added_to_this_reservation")}</span>
          </legend>
          <div className="reservation-segments" ref="segments">
            {segments}
          </div>
        </fieldset>
      );
    } else {
      return (
        <fieldset>
          <legend>
            <span>{I18n.t("rooms_added_to_this_reservation")}</span>
          </legend>
          <div className="reservation-segments" ref="segments">
            <p className="lead text-center no-reservation-segments">
              <span className="none">{I18n.t("none")}</span>
            </p>
          </div>
        </fieldset>
      );
    }
  }
}
